<!--企业物流管理页面-->
<template>
    <div id="goodSearch" class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button size="small" class="search-btn btn-primary" v-if="permission.add" @click="add(1)">{{ permission.add }}</el-button>
                <el-button size="small" icon="el-icon-files" class="search-btn btn-primary" @click="gotoImportPage()" v-if="permission.importExcel">{{
                    permission.importExcel
                }}</el-button>
                <el-button size="small" class="search-btn btn-primary" v-if="permission.export" @click="exportForm">
                    <i class="fa fa-file-excel-o"></i>
                    {{ permission.export }}</el-button
                >
            </div>
            <div class="search-ctn-right">
                <div class="search-name">物流名称</div>
                <el-select
                    class="search-item"
                    size="small"
                    v-model="searchData.Name"
                    remote
                    filterable
                    allow-create
                    placeholder="请输入物流公司名称"
                    :remote-method="querySearch"
                    v-select-scroll-more="searchLcLoad"
                    popper-class="my-select"
                >
                    <el-option v-for="item in lcOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusName">
                        <div class="name">
                            {{ item.EntpCusName }}
                            <span v-if="item.Phone" class="phone">{{ ` ( 电话：${item.Phone} )` }}</span>
                        </div>
                    </el-option>
                </el-select>

                <div class="search-name">联系人</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.Contacts" placeholder="请输入联系人"></el-input>
                <div class="search-name">电话</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.Phone" placeholder="手机号或联系电话"></el-input>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
            </div>
        </div>
        <template v-if="noData">
            <div class="no-data">暂无数据</div>
        </template>
        <template v-else>
            <div class="table-ctn">
                <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border style="width: 100%" @cell-dblclick="handleDBClick">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column min-width="150px" prop="Name" label="名称" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="100px" prop="Contacts" label="联系人" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="100px" prop="Phone" label="手机号" show-overflow-tooltip></el-table-column>
                    <el-table-column width="100px" prop="Telephone" label="联系电话" show-overflow-tooltip></el-table-column>
                    <el-table-column width="300px" label="地址" show-overflow-tooltip>
                        <template slot-scope="scope"> {{ scope.row.Province }}{{ scope.row.City }}{{ scope.row.District }}{{ scope.row.AddrDetail }} </template>
                    </el-table-column>
                    <el-table-column min-width="100px" prop="CreateTime" label="创建时间" show-overflow-tooltip></el-table-column>

                    <el-table-column fixed="right" label="操作" :autoWidth="true">
                        <template slot-scope="scope">
                            <div class="ops-ctn">
                                <el-button title="编辑" size="mini" type="text" v-if="permission.edit" @click="add(2, scope.row)">编辑</el-button>
                                <el-button size="mini" style="color: red" @click="del(scope.row)" v-if="permission.del" type="text">删除</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                ></el-pagination>
            </div>
        </template>
        <el-dialog
            :close-on-click-modal="false"
            :title="dialogEditType == 1 ? '新增物流公司' : dialogEditType == 2 ? '编辑物流公司' : '查看物流公司'"
            :visible.sync="dialogEditVisible"
            width="1000px"
        >
            <div class="dialog-content" v-if="dialogEditVisible">
                <logisticsCompanyEdit ref="logisticsCompanyEdit" :compId="editCompId" :type="dialogEditType" @closeDialog="closeDialog"></logisticsCompanyEdit>
            </div>
        </el-dialog>
        <el-progress type="circle" :percentage="percentage" class="saveProgress" :class="{ hide: !saveLoading }"></el-progress> 
        <div style="z-index: 2001" class="exportmsg" v-if="showExportMsg">
            <span>数据已经准备好，正在生成Excel表格，可能耗时1-5min，请耐心等候……</span>
            <span>您也可以打开新的窗口进行其他的操作</span>
        </div>
    </div>
</template>
<script>
import mixin from '@/mixins/mixin';
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import pageLimitMixin from '@/mixins/pageLimitMixin';
import logisticsCompanyEdit from '@/components/logistics/logisticsCompanyEdit';
export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: { elTableColumn, breadcrumb, logisticsCompanyEdit },
    data() {
        return {
            noData: false,
            dialogEditVisible: false,
            dialogEditType: 1, //1新增，2编辑，3查看
            editCompId: '',
            searchData: {
                Name: '',
                Contacts: '',
                Phone: '',
                page: 1,
                limit: 15
            },
            tableData: [],
            tableDataLength: 0,
            permission: {},
            // 用于物流公司列表，分页搜索
            lcOptions: [],
            lcForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            saveLoading: false,
            percentage: 0, //进度
            currtPage: 1, //页面，表示保存到第几页,
            saveCount: 0, //已保存数
            showExportMsg: false
        };
    },
    mounted() {
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.getTableData();
        this.querySearch();
        this.permission = this.$util.getPermission('entpLine');
    },
    methods: {
        resetSearch() {
            this.searchData = {
                Name: '',
                Contacts: '',
                Phone: '',
                page: 1,
                limit: this.commonPageSize
            };
            this.querySearch('');
        },
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/EntpCustomers/GetEntpLogCompanyList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) {
                        this.noData = true;
                        return;
                    }
                    this.noData = false;
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .catch(() => {});
        },
        async querySearch(key) {
            if (![undefined].includes(key)) {
                this.lcForm.Page = 1;
                this.lcForm.stopLoad = false;
                this.lcForm.key = key;
                this.lcOptions = [];
            }
            if (this.lcForm.stopLoad) return;
            const data = await this.$util.searchLogistic(this.lcForm.key, this.lcForm.Page, this.lcForm.Limit);
            if (data) {
                if (!data) return;
                this.lcForm.stopLoad = data.length < this.lcForm.Limit;
                this.lcOptions = [...this.lcOptions, ...data];
            }
        },
        // 客户名称列表，加载更多
        searchLcLoad() {
            this.lcForm.Page += 1;
            this.querySearch();
        },
        del(row) {
            let that = this;
            this.$util.elConfirm({
                content: '确定要删除该物流公司吗？',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: '/api/EntpCustomers/DelEntpLogCompany?id=' + row.Id
                        })
                        .then(() => {
                            that.searchData.page = 1;
                            that.$util.successMsg('删除成功');
                            that.getTableData();
                        })
                        .catch(() => {});
                }
            });
        },
        add(type, item) {
            this.editCompId = '';
            this.dialogEditType = type;
            if (type == 2 || type == 3) {
                this.editCompId = item.Id;
            }
            this.dialogEditVisible = true;
        },
        closeDialog(edit) {
            this.editCompId = '';
            this.dialogEditVisible = false;
            if (edit) {
                this.getTableData();
            }
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        //表单双击事件
        handleDBClick(event) {
            if (event) {
                this.add(3, event);
            }
        },
        gotoImportPage() {
            this.$router.push('/logistics/importExcel');
        },
        // 导出
        exportForm() {
            let that = this;
            this.$util.elConfirm({
                content: '确定导出物流明细表吗？',
                noMsg: true,
                confirm() {
                    that.exportData();
                }
            });
        },
        exportData() {
            let that = this;
            if (that.tableData.length == 0) {
                that.$util.warningMsg('请筛选数据');
                return;
            }
            that.saveLoading = true;
            let saveLimit = 100;
            if (that.tableDataLength < saveLimit) saveLimit = that.tableDataLength;

            let reqData = { ...that.searchData };
            reqData._Limit = saveLimit;
            reqData._Page = that.currtPage;

            that.$util
                .axiosGet({
                    url: '/api/EntpCustomers/GetEntpLgisToExport',
                    data: reqData,
                    hideLoading: true
                })
                .then(resp => {
                    that.saveCount += saveLimit;
                    let num = parseFloat(that.saveCount);
                    let total = parseFloat(that.tableDataLength);
                    that.percentage = total <= 0 ? 0 : Math.round(Math.round((num / total) * 10000) / 100.0);
                    that.percentage = that.percentage > 100 ? 100 : that.percentage;
                    if (that.tableDataLength <= that.saveCount) {
                        that.showExportMsg = true;
                        that.$util
                            .exportFile({
                                url: '/api/EntpCustomers/ExportEntpLogis'
                            })
                            .then(res => {
                                that.percentage = 0;
                                that.saveCount = 0;
                                that.currtPage = 1;
                                that.saveLoading = false;
                                that.showExportMsg = false;
                                that.$util.successMsg('导出成功');
                            });
                    } else {
                        that.currtPage++;
                        that.exportData();
                    }
                })
                .catch(() => {
                    that.percentage = 0;
                    that.saveCount = 0;
                    that.currtPage = 1;
                    that.saveLoading = false;
                });
        }
    }
};
</script>
<style lang="less" scoped>
.qp-msg {
    padding-bottom: 10px;
    p {
        padding-top: 10px;
    }
}
.qp-ctn {
    display: flex;
    flex-wrap: wrap;
}
.qp-item {
    width: 250px;
    margin-right: 20px;
    margin-bottom: 20px;
}
.qp-cover {
    text-align: center;
    overflow: hidden;
    img {
        max-height: 218px;
        max-width: 218px;
    }
}
.ops-ctn {
    display: flex;
}
@media screen and (max-width: 1675px) {
    .table-ctn {
        height: calc(100% - 162px);
        overflow-y: auto;
    }
}
@media screen and (min-width: 1675px) {
    .table-ctn {
        height: calc(100% - 98px);
        overflow-y: auto;
    }
}
.my-select {
    li {
        line-height: normal;
        padding: 7px;

        .name {
            text-overflow: ellipsis;
            overflow: hidden;
        }
        .phone {
            font-size: 12px;
            color: #b4b4b4;
        }

        .highlighted .phone {
            color: #ddd;
        }
    }
}
.saveProgress {
    position: absolute;
    top: 45%;
    left: 45%;
    z-index: 9999;
}
.exportmsg {
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 10000;
    position: absolute;
    top: 65vh;
    left: 60vh;
    font-size: 22px;
    color: rgb(243, 62, 62);
}
</style>
<style lang="less">
.el-table .warning-row {
    background: oldlace;
}
.el-table .success-row {
    background: #f0f9eb;
}
.el-table .error-row {
    background: rgb(255, 176, 176);
}
</style>
